import React, { createContext } from 'react';
import {
  arrayOf,
  bool,
  node,
  number,
  oneOfType,
  shape,
  string
} from 'prop-types';
import { useCalculator } from '../../hooks/useCalculator';

export const CalculatorContext = createContext({});

export const CalculatorProvider = ({
  allowAdditionalCoverage,
  calculatorType = '',
  children,
  info,
  lineItemName = 'Area',
  unitsPerCase
}) => {
  const [
    calculate,
    {
      addElement, calculateTotal, removeInputElement, saveToLocalStorageFunc, setCalculate
    }
  ] = useCalculator({
    allowAdditionalCoverage, calculatorType, info, lineItemName, unitsPerCase
  });

  return (
    <CalculatorContext.Provider value={{
      addElement,
      calculate,
      calculateTotal,
      calculatorType,
      lineItemName,
      removeInputElement,
      saveToLocalStorageFunc,
      setCalculate
    }}
    >
      {children}
    </CalculatorContext.Provider>
  );
};

CalculatorProvider.propTypes = {
  allowAdditionalCoverage: bool,
  calculatorType: string,
  children: oneOfType([
    arrayOf(node),
    node
  ]).isRequired,
  info: shape({
    classNumber: string,
    productDepartment: string
  }).isRequired,
  lineItemName: string.isRequired,
  unitsPerCase: oneOfType([string, number])
};

CalculatorProvider.defaultProps = {
  allowAdditionalCoverage: false,
  calculatorType: '',
  unitsPerCase: '0'
};
